module.exports = __webpack_public_path__ + "img/Bodice-Front-B1-Db-Ed-Gb.64b5ee7a.png";